// extracted by mini-css-extract-plugin
export default {"card":"N4-z"};